<button #button
        (click)="check()"
        [attr.aria-checked]="isChecked"
        [attr.tabIndex]="isChecked ? 0 : -1"
        [class.checked]="isChecked"
        class="segmented-button"
        role="radio"
        type="button">{{ name }}
</button>
